import React from "react";
import { styled as muiStyled } from "@mui/system";
import { Avatar } from "@mui/material";

const StyledAvatar = muiStyled(
  Avatar,
  {}
)(({ theme }) => ({
  [theme.breakpoints.up("tablet")]: {
    height: "20px",
    width: "20px",
  },
  [theme.breakpoints.up("laptop")]: {
    height: "40px",
    width: "40px",
  },
}));

export const UserAvatar = (props) => {
  return <StyledAvatar src={props.src} />;
};
